import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import GlobalFooter from './GlobalFooter';

function PendingEur() {

    const location = useLocation();
    const { redirectUrl, reference } = location.state?.result || {};
    
    useEffect(() => {
        // Only redirect if `redirectUrl` is available and does not start with "NA"
        if (redirectUrl && redirectUrl.startsWith('http')) {

            const timer = setTimeout(() => {
                window.location.href = redirectUrl; 
            }, 3000);
            // Cleanup timer in case the component unmounts before the timer completes
            return () => clearTimeout(timer);
        }
    }, [redirectUrl]);
    // const { reference } = location.state || {};
    const navigate = useNavigate()
    const record = JSON.parse(localStorage.getItem('yapil'));
    

    const handleClick =()=>{
        if (redirectUrl && redirectUrl.startsWith('http')) {
            window.location.href = redirectUrl;
        }
        // navigate(`/pages/payment-credential?${queryParams}`)
    }
  return (
    <div className='global_layout'>
         {
         /* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
            } */
         }
    
        <div className='global_container'>
            <div className='top_bar'>
                {/* <img src='/images/global/arrow-left.svg' alt=''/> */}
                {/* <img src='/images/global/close.svg' alt='' style={{marginLeft:"auto"}} /> */}
            </div>

            <div className='global_content'>
                <img style={{width:"60px",height:"60px"}} src='/images/global/success.gif' alt='' />
                <p className='glob_title'>Successful!</p>
                <p className='glob_desc'>Payment has been successfully initiated.</p>
                {
                    reference &&
                    <p className='glob_desc'>Reference: <span style={{fontWeight:"700"}}>{reference}</span></p>
                }
                {/* <button className='btn' style={{marginTop:"18px",background:"#228985",borderRadius:"10000px"}} onClick={handleClick}>Try again</button> */}
            </div>
        </div>
        {/* {
           !record?.total_whitelabelling &&
            <GlobalFooter />
        } */}
    </div>
  )
}

export default PendingEur